import { createGet, createPost } from "./http";

export interface Settings {
  show: boolean;
}

export const getSettings = createGet<Settings>("/settings");

export const changeSettings = createPost<Settings, Settings>(
  "/settings/change"
);

export interface UserInfo {
  login: string;
  avatarUrl: string;
  type: string;
  name: string;
  roles?: string[];
}

export const getUserInfo = createGet<UserInfo>("/user");

export interface LogoutStatus {
  status: number;
}
export const logout = createPost<LogoutStatus>("/user/logout");

export interface UserData {
  _id: string;
  createAt: string;
  updateAt: string;
  type: string;
  login: string;
  loginLower: string;
  roles: string[];
  avatarUrl: string;
  id: number;
  name: string;
  show: boolean;
}

export interface ListPage {
  total: number;
  page: number;
  limit: number;
}
export interface UserListRes {
  list: UserData[];
  pages: ListPage;
}

export type SortValue = 1 | -1;
export interface GetUserListQuery {
  login?: SortValue;
  name?: SortValue;
  createAt?: SortValue;
  updateAt?: SortValue;
  show?: boolean;
  page?: number;
  limit?: number;
}
export const getUserList = createGet<UserListRes, GetUserListQuery>(
  "/user/list"
);

export interface AddUserProps {
  login: string;
  show: boolean;
  type: string;
}

export const addUser = createPost<AddUserProps, UserInfo>("/user/add");
